import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-browse-placeholder',
  templateUrl: './browse-placeholder.component.html',
  styleUrls: ['./browse-placeholder.component.scss']
})
export class BrowsePlaceholderComponent implements OnInit {

  @Input() public isMobile;

  constructor() { }

  ngOnInit() {
  }

  get getNumber() {
    if (this.isMobile) {
      return [].constructor(1);
    } else {
      return [].constructor(3);
    }
  }

  get getWidgets() {
    if (this.isMobile) {
      return [].constructor(2);
    } else {
      return [].constructor(6);
    }
  }

}
